import React from "react";
import { Lightbulb, Target, AlertTriangle, Shield } from "lucide-react";

// Each tip type uses a white card with a colored LEFT accent rail — keeps the
// page visually light and lets the 3 columns read as a unified strip rather
// than three loud color blocks.
const META = {
  tip:      { icon: Lightbulb,     accent: "#DBB90A", label: "Tip",        labelColor: "text-[#8A6B00]" },
  reminder: { icon: Target,        accent: "#0A3D79", label: "Reminder",   labelColor: "text-[#0A3D79]" },
  pitfall:  { icon: AlertTriangle, accent: "#c05746", label: "Watch out",  labelColor: "text-[#8a2e1a]" },
  dhs:      { icon: Shield,        accent: "#1FA0E6", label: "DHS Rule",   labelColor: "text-[#0f3b5f]" },
};

/**
 * TipStrip — inline row of tip / reminder / pitfall / DHS cards above a step.
 * items: Array<{ type: 'tip' | 'reminder' | 'pitfall' | 'dhs', text: string }>
 */
export default function TipStrip({ items = [], testid = "tip-strip" }) {
  if (!items.length) return null;
  return (
    <div className="grid md:grid-cols-3 gap-3 mb-6" data-testid={testid}>
      {items.map((item, i) => {
        const m = META[item.type] || META.tip;
        const Icon = m.icon;
        return (
          <div
            key={`${item.type}-${item.text}`}
            className="relative rounded-xl bg-white border border-[#E7EEF3] pl-4 pr-3.5 py-3 flex items-start gap-2.5 overflow-hidden"
            style={{ boxShadow: "0 1px 2px rgba(11,30,58,0.04)" }}
            data-testid={`${testid}-${item.type}-${i}`}
          >
            {/* Left accent rail */}
            <div
              className="absolute left-0 top-0 bottom-0 w-1"
              style={{ backgroundColor: m.accent }}
              aria-hidden="true"
            />
            <div
              className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
              style={{ backgroundColor: `${m.accent}18`, color: m.accent }}
            >
              <Icon className="w-3.5 h-3.5" strokeWidth={2} />
            </div>
            <div className="min-w-0">
              <div className={`text-[10.5px] uppercase tracking-[0.14em] font-semibold ${m.labelColor} mb-0.5`}>
                {m.label}
              </div>
              <div className="text-[12.5px] text-[#0B1E3A] leading-snug">{item.text}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
